import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import { useCookies } from 'react-cookie'; // ✅ importación obligatoria
import TarjetaPresion from "../components/visor/TarjetaPresion";
import "./Visor.css";
import Nav from "../components/Nav";
import ResumContainer from "../components/visor/ResumContainer";
import RoadMap from "../components/visor/RoadMap";

  /**************************************************
   * 
   *  24-07-2055
   *  es el monitor de presiones en tiempo real
   *  para un equipo en particular 
   *
   * 
   ***************************************************/



   //-----------------------------startn----------------------------  
  

  

const Visor = ({ user, logout }) => {


  const [datos, setData] = useState(null); 
  const [last, setLast] = useState(null);
  const [cookies] = useCookies(['session_id', 'user']);

    // Extraer ID desde la URL
  const params = new URLSearchParams(window.location.search);
  const id = params.get('id');
  const equipo= params.get('id');
  const serie= params.get('serie');
  let modelo = params.get('modelo');

  if(modelo === '798_LPP'){
    modelo = '798'
  }
  if(modelo === '797B_PTT'){
    modelo = '797B'
  }


  const updateLast = () => {
    const host = window.location.hostname;
    const isProd = process.env.NODE_ENV === 'production';
    const url = isProd
    ? 'api/getLastSingle/index.php'
    : `http://${host}/react_projects/ISIGHT_v2/src/api/getLastSingle/index.php`; //para conectar ipad o ipone por red

 
 
    //---------------------------------- FETCH   -----------------------------   

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        serie: serie,
        modelo: modelo,
        task: 'get',
        Authorization: 'Client-ID ' + cookies.session_id,
        tkd: id
      })
    })
      .then((res) => res.json())
      .then((i) => {
        setData(i.data);
        setLast(i.last_unix);
        //console.log(i.data)
      })
      .catch((err) => {
        console.log('Error de datos:\n' + err);
      });
  };

   //******************************  end function ************************* */

  useEffect(() => {
    updateLast();
    const intervalId = setInterval(updateLast, 60000);// one minute
    return () => clearInterval(intervalId);
  }, []);


  



  const direccionData = {
    "798": ['direccion_1', 'direccion_2', 'direccion_3', 'direccion_4', 'direccion_5', 'direccion_6'],
    "960E": ['direccion_1', 'direccion_2'],
    "797B": ['direccion_1', 'direccion_2', 'direccion_3'],
    "797F": ['direccion_1', 'direccion_2', 'direccion_3'],
    "797B_LPP": ['direccion_1', 'direccion_2', 'direccion_3'],
    "793F": ['direccion_1', 'direccion_2', 'direccion_3'],
  };

  const frenoData = {
    "798": ['freno_1', 'freno_2', 'freno_3'],
    "960E": ['freno_1', 'freno_2'],
    "797B": ['freno_1', 'freno_2'],
    "797F": ['freno_1', 'freno_2', 'freno_3'],
    "797B_LPP": ['freno_1', 'freno_2'],
    "793F": ['freno_1', 'freno_2', 'freno_3'],
    "777": ['freno_1', 'freno_2', 'freno_3'],
    "777F": ['freno_1', 'freno_2', 'freno_3'],
    "777G": ['freno_1', 'freno_2', 'freno_3'],
    "EEAA": ['freno_1', 'freno_2'],
    "854K": ['freno_1', 'freno_2'],
    "24M": ['freno_1', 'freno_2'],
    "994F": ['freno_1', 'freno_2'],
    "988H": ['freno_1', 'freno_2'],
    "988G": ['freno_1', 'freno_2'],
  };


  const renderCharts = (dataArray,type,modelo) =>
    dataArray.map((value, i) => {
    const sufijo = value.split('_')[1];
    // Construir la clave dinámica (por ejemplo, 'f1' o 'd2')(que es como viene el objeto data.d1 pej.)
    const key = type === 'fre' ? `f${sufijo}` : `dir${sufijo}`;
    const imgKey = type === 'fre' ? `f${sufijo}` : `d${sufijo}`;
    //let imgx = `../img/${modelo}/${imgKey}.png`
    let imgx = `img/${modelo}/${imgKey}.png`
      return (
        <div key={`${i}`}>
          <TarjetaPresion 
            imagen = {imgx}
            /*presion1={datos?.f1 ?? '---'} */
            presion1={datos?.[key] ?? '---'}
            task={value} 
            titulo={value} 
            last = {last}
            />
        </div>
      );
  });



  return (
    <>
    <Nav user={user} logout={() => logout(false)} cookDestr={logout} />

    <main style={{ padding: "20px" }}  className="visor-container" >
      
      <div className="visor-title">
          <div> {modelo} - {equipo}</div>
          <div className="sm-title"> {serie}</div>
      </div>

      
      
      <section>
        <div className="subtitle-container">


        {/* ------    road map header   -----------------*/}

        <div className="roadContainer">
          <div className="portrait-wrapper">
            <img src={`img/${modelo}/portrait.png`} alt="portrait" />
          </div>
          <div className="roadmap-wrapper">
            <RoadMap />
          </div>
        </div>
        {/* ------    road map header   -----------------*/}


        <div className="separator">      
        </div>


        <div className="visor-subtitle">Presion de Nitrogeno con el motor detenido</div>
        </div>
         <ResumContainer imagen=""  last = {last}/>
    
        <br></br>


        {direccionData[modelo] && renderCharts(direccionData[modelo], "dir",modelo)}

        <div style={{ flexBasis: "100%" }} />

        {frenoData[modelo] && renderCharts(frenoData[modelo], "fre",modelo)}

      </section>
    </main>
    </>
  );
};

export default Visor;
